export default __webpack_public_path__ + "static/media/734.d8a47cde.gif";